// extracted by mini-css-extract-plugin
export default {"steps":"ZK-z","header":"_K-z","description":"aL-z"};